import { IntEnumConditions, StringConditions } from '../../../grid/gridFilters/types';

export interface RelayPatchCachingServersWebComponentSchema {}

export interface RelayCachingServer {
  _id: string;
  name: string;
  ip: string;
  customHostname: string;
  specifics: any;
}

export enum Column {
  PRIORITY,
  NAME,
  CUSTOMHOST,
  ACTIONS,
}

export enum ColumnKeys {
  PRIORITY = 'priority',
  NAME = 'name',
  ACTIONS = 'actions',
  CUSTOMHOST = 'customHostName',
}

export interface DataGridItem {
  priority?: string;
  protectedEntityId: string;
  name: string;
  ip: string;
  dnsHostName: string;
  fqdn: string;
  actions?: string;
  customHostName?: string;
}

export interface DataGridItemsResponse {
  rawEvents: Array<DataGridItem>;
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export interface Filter {
  priority?: IntEnumConditions;
  relay?: StringConditions;
}

export const COLUMNS = [0, 1, 2, 3];

export const FILTERS = [{ relay: { contains: '' } }];

export const PREDEFINED_FILTERS_KEYS = [];

export enum EVENTS {
  CACHING_SERVERS_NUMBER_UPDATED = 'cachingServersNumberUpdated',
}
